import React from 'react';
import Switch from 'react-switch';

const CustomSwitch = ({ checked, onChange, ...restOfProps }) => (
  <Switch
    onChange={onChange}
    checked={checked}
    onColor="#6FD7AA"
    onHandleColor="#0FBC71"
    offColor="#9E9E9E"
    handleDiameter={20}
    uncheckedIcon={false}
    checkedIcon={false}
    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
    height={14}
    width={34}
    className="react-switch"
    {...restOfProps}
  />
);

export default CustomSwitch;
